import React, { Component } from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import Page from "../../../components/Page";
import {
  Grid,
  Header,
  Icon,
  Segment,
  Card,
  Statistic,
  Table,
} from "semantic-ui-react";
import { log, get } from "../../../util/api";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import moment from "moment";

const barOptions = {
  maintainAspectRatio: false,
  responsive: true,
  scales: {
    xAxes: [
      {
        gridLines: { display: false },
      },
    ],
    yAxes: [
      {
        ticks: { min: 0, beginAtZero: true },
        gridLines: { color: "#f0f0f0" },
      },
    ],
  },
  legend: {
    display: false,
  },
  tooltips: {
    callbacks: {
      label: function (tooltipItem, data) {
        return (
          data.labels[tooltipItem.index] +
          ": " +
          tooltipItem.yLabel.toLocaleString()
        );
      },
    },
  },
};

const doughnutOptions = {
  maintainAspectRatio: false,
  responsive: true,
  legend: {
    position: "bottom",
  },
  tooltips: {
    callbacks: {
      label: function (tooltipItem, data) {
        const total = data.datasets[0].data.reduce((a, b) => a + b, 0);
        const percentage = (
          (data.datasets[0].data[tooltipItem.index] / total) *
          100
        ).toFixed(1);
        return (
          data.labels[tooltipItem.index] +
          ": " +
          data.datasets[0].data[tooltipItem.index].toLocaleString() +
          " (" +
          percentage +
          "%)"
        );
      },
    },
  },
};

class BirSansVerAnalytic extends Component {
  state = {
    loading: true,
    data: null,
    giveChanceCampId: null,
    orderData: null,
  };

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(oldProps) {
    if (this.props.newDataToggle !== oldProps.newDataToggle) {
      this.loadData();
    }
  }

  async loadData() {
    this.setState({ loading: true });
    try {
      let { start_date, end_date } = this.props;
      let pid = this.props.product.id;

      const campaignResponse = await get("/campaign");
      const birSansVerCampaign = campaignResponse.data.find(
        (item) => item.name === "Reklam Kazanım Asistanı"
      );

      if (!birSansVerCampaign) {
        console.error("Reklam Kazanım Asistanı kampanyası bulunamadı");
        this.setState({
          loading: false,
          data: null,
          giveChanceCampId: null,
        });
        return;
      }

      const giveChanceCampId = birSansVerCampaign.id.toString();

      // Check if the selected date range is 'Today'
      const start = moment(start_date);
      const end = moment(end_date);
      const isToday =
        start.isSame(moment(), "day") && end.isSame(moment(), "day");

      let filteredData = [];
      let previousFilteredData = null;
      let previousStartDate = null;
      let previousEndDate = null;

      if (isToday) {
        const analyticsResponse = await log("/collectaction/getInfo?date", {
          start_date,
          end_date,
          filter: { pid, camp_id: giveChanceCampId },
          select: [],
          group: ["type", "camp_id", "select2", "select3"],
          pairs: {},
          options: {
            total_count: "sum(count1)",
            count_with_order: "sum(count2)",
            count_with_the_order: "sum(count3)",
            unique_user: "count(distinct select1)",
            total_session: "count(*)",
          },
        });
        filteredData = analyticsResponse.data.result.filter(
          (item) => item.camp_id === giveChanceCampId
        );
      } else {
        // Calculate previous period
        const diffDays = end.diff(start, "days") + 1;
        previousStartDate = start
          .clone()
          .subtract(diffDays, "days")
          .format("YYYY-MM-DD");
        previousEndDate = end
          .clone()
          .subtract(diffDays, "days")
          .format("YYYY-MM-DD");

        const [currentResponse, previousResponse] = await Promise.all([
          log("/collectaction/getInfo?date", {
            start_date,
            end_date,
            filter: { pid, camp_id: giveChanceCampId },
            select: [],
            group: ["type", "camp_id", "select2", "select3"],
            pairs: {},
            options: {
              total_count: "sum(count1)",
              count_with_order: "sum(count2)",
              count_with_the_order: "sum(count3)",
              unique_user: "count(distinct select1)",
              total_session: "count(*)",
            },
          }),
          log("/collectaction/getInfo?date", {
            start_date: previousStartDate,
            end_date: previousEndDate,
            filter: { pid, camp_id: giveChanceCampId },
            select: [],
            group: ["type", "camp_id", "select2", "select3"],
            pairs: {},
            options: {
              total_count: "sum(count1)",
              count_with_order: "sum(count2)",
              count_with_the_order: "sum(count3)",
              unique_user: "count(distinct select1)",
              total_session: "count(*)",
            },
          }),
        ]);

        filteredData = currentResponse.data.result.filter(
          (item) => item.camp_id === giveChanceCampId
        );

        previousFilteredData = previousResponse.data.result.filter(
          (item) => item.camp_id === giveChanceCampId
        );
      }

      const orderData = filteredData.filter(
        (item) => item.type === "tagOrder" && item.select3
      );

      this.setState({
        loading: false,
        data: filteredData,
        previousData: previousFilteredData,
        giveChanceCampId,
        previousStartDate: isToday ? null : previousStartDate,
        previousEndDate: isToday ? null : previousEndDate,
        orderData,
      });
    } catch (error) {
      console.error("Veri yükleme hatası:", error);
      this.setState({
        loading: false,
        giveChanceCampId: null,
      });
    }
  }

  calculateMetrics(data) {
    if (!data || !data.length)
      return {
        totalVisit: 0,
        capture: 0,
        pageReturn: 0,
        productReturn: 0,
        addToCart: 0,
        purchase: 0,
        captureRate: 0,
        returnRate: 0,
        productRate: 0,
        cartRate: 0,
        purchaseRate: 0,
      };

    const totalVisit = data
      .filter((item) => item.type === "campaignShown")
      .reduce((sum, item) => sum + parseInt(item.total_count || 0), 0);

    const capture = data
      .filter((item) => item.type === "tagClick")
      .reduce((sum, item) => sum + parseInt(item.total_count || 0), 0);

    const pageReturn = data
      .filter((item) => item.type === "tagReturn")
      .reduce((sum, item) => sum + parseInt(item.total_count || 0), 0);

    const productReturn = data
      .filter((item) => item.type === "tagProductClick")
      .reduce((sum, item) => sum + parseInt(item.total_count || 0), 0);

    const addToCart = data
      .filter((item) => item.type === "tagProductAddedToBasket")
      .reduce((sum, item) => sum + parseInt(item.total_count || 0), 0);

    const purchase = data
      .filter((item) => item.type === "tagOrder")
      .reduce((sum, item) => sum + parseInt(item.total_count || 0), 0);

    return {
      totalVisit,
      capture,
      pageReturn,
      productReturn,
      addToCart,
      purchase,
      captureRate: totalVisit ? ((capture / totalVisit) * 100).toFixed(2) : 0,
      returnRate: capture ? ((pageReturn / capture) * 100).toFixed(2) : 0,
      productRate: pageReturn
        ? ((productReturn / pageReturn) * 100).toFixed(2)
        : 0,
      cartRate: productReturn
        ? ((addToCart / productReturn) * 100).toFixed(2)
        : 0,
      purchaseRate: addToCart
        ? ((purchase / addToCart) * 100).toFixed(2)
        : 0,
    };
  }

  getMetrics() {
    return this.calculateMetrics(this.state.data);
  }

  normalizeReferrer(referrer) {
    if (!referrer) return "Other";

    let normalized = referrer.toLowerCase().trim();

    normalized = normalized
      .replace(/^https?:\/\//, "")
      .replace(/^www\./, "")
      .replace(/^m\./, "")
      .replace(/\/$/, "");

    if (
      normalized.includes("instagram") ||
      normalized.includes("instagram.com") ||
      normalized.includes("instagram")
    ) {
      return "Instagram";
    }

    if (
      normalized.includes("facebook") ||
      normalized.includes("facebook.com") ||
      normalized.includes("fb.com")
    ) {
      return "Facebook";
    }

    if (
      normalized.includes("google") ||
      normalized.includes("google.com") ||
      normalized.includes("google.")
    ) {
      return "Google";
    }

    return "Other";
  }

  calculateReferrerData(data) {
    if (!data || !data.length) return [];

    const referrerMap = {};

    data.forEach((item) => {
      const normalizedReferrer = this.normalizeReferrer(item.select2);
      const type = item.type;

      if (!referrerMap[normalizedReferrer]) {
        referrerMap[normalizedReferrer] = {
          referrer: normalizedReferrer,
          campaignShown: 0,
          tagClick: 0,
          tagReturn: 0,
          tagProductClick: 0,
          tagProductAddedToBasket: 0,
        };
      }

      referrerMap[normalizedReferrer][type] += parseInt(item.total_count || 0);
    });

    return Object.values(referrerMap)
      .map((item) => ({
        ...item,
        captureRate: item.campaignShown
          ? ((item.tagClick / item.campaignShown) * 100).toFixed(2)
          : 0,
        returnRate: item.tagClick
          ? ((item.tagReturn / item.tagClick) * 100).toFixed(2)
          : 0,
        productRate: item.tagReturn
          ? ((item.tagProductClick / item.tagReturn) * 100).toFixed(2)
          : 0,
        cartRate: item.tagProductClick
          ? (
              (item.tagProductAddedToBasket / item.tagProductClick) *
              100
            ).toFixed(2)
          : 0,
      }))
      .sort((a, b) => b.campaignShown - a.campaignShown);
  }

  getFunnelChartData() {
    const metrics = this.getMetrics();

    const labels = [
      this.props.t("TotalVisit"),
      this.props.t("CaptureText"),
      this.props.t("CategoryReturnText"),
      this.props.t("ProductReturnText"),
      this.props.t("AddToCartText"),
    ];
    const data = [
      metrics.totalVisit,
      metrics.capture,
      metrics.pageReturn,
      metrics.productReturn,
      metrics.addToCart,
    ];
    const colors = ["#2c3e50", "#2185d0", "#21ba45", "#f2711c", "#9b59b6"];

    return {
      labels,
      datasets: [
        {
          label: "Kullanıcı Sayısı",
          data,
          backgroundColor: colors.map((color) => color + "40"),
          borderColor: colors,
          borderWidth: 2,
        },
      ],
    };
  }

  getPieChartData() {
    const metrics = this.getMetrics();
    const total = metrics.totalVisit;

    if (total === 0) return { labels: [], datasets: [] };

    const labels = [
      this.props.t("UndetectedVisits"),
      this.props.t("DetectedVisits"),
    ];
    const data = [total - metrics.capture, metrics.capture];

    return {
      labels,
      datasets: [
        {
          data,
          backgroundColor: ["#e74c3c40", "#2185d040"],
          borderColor: ["#e74c3c", "#2185d0"],
          borderWidth: 2,
        },
      ],
    };
  }

  getReferrerChartData() {
    const referrerData = this.getReferrerData();

    if (!referrerData.length) return { labels: [], datasets: [] };

    const labels = referrerData.map((item) => item.referrer);
    const colors = [
      "#3498db",
      "#e74c3c",
      "#2ecc71",
      "#f39c12",
      "#9b59b6",
      "#1abc9c",
    ];

    return {
      labels,
      datasets: [
        {
          label: this.props.t("TotalVisit"),
          data: referrerData.map((item) => item.campaignShown),
          backgroundColor: colors[0] + "40",
          borderColor: colors[0],
          borderWidth: 2,
        },
        {
          label: this.props.t("CaptureText"),
          data: referrerData.map((item) => item.tagClick),
          backgroundColor: colors[1] + "40",
          borderColor: colors[1],
          borderWidth: 2,
        },
        {
          label: this.props.t("CategoryReturnText"),
          data: referrerData.map((item) => item.tagReturn),
          backgroundColor: colors[2] + "40",
          borderColor: colors[2],
          borderWidth: 2,
        },
        {
          label: this.props.t("ProductReturnText"),
          data: referrerData.map((item) => item.tagProductClick),
          backgroundColor: colors[3] + "40",
          borderColor: colors[3],
          borderWidth: 2,
        },
        {
          label: this.props.t("AddToCartText"),
          data: referrerData.map((item) => item.tagProductAddedToBasket),
          backgroundColor: colors[4] + "40",
          borderColor: colors[4],
          borderWidth: 2,
        },
      ],
    };
  }

  render() {
    const {
      loading,
      giveChanceCampId,
      data,
      previousStartDate,
      previousEndDate,
      orderData,
    } = this.state;
    let { t, giveChanceOrderAnalytic } = this.props;

    if (loading) return <Page.Loader />;

    if (!giveChanceCampId) {
      return (
        <div style={{ padding: "20px", textAlign: "center" }}>
          <Header as="h3" color="red">
            <Icon name="warning sign" />
            Reklam Kazanım Asistanı kampanyası bulunamadı
          </Header>
          <p>
            Bu müşteri için "Reklam Kazanım Asistanı" kampanyası tanımlanmamış
            olabilir.
          </p>
        </div>
      );
    }

    if (!data || data.length === 0) {
      return (
        <div style={{ padding: "20px", textAlign: "center" }}>
          <Header as="h3" color="orange">
            <Icon name="calendar times" />
            Seçilen Tarih Aralığı İçin Veri Bulunamadı
          </Header>
          <p>
            Seçili tarih aralığında "Reklam Kazanım Asistanı" kampanyasına ait herhangi bir aksiyon (ziyaret, tıklama vb.) kaydedilmemiştir.
          </p>
          <p style={{ marginTop: "15px", fontSize: "14px", color: "#7f8c8d" }}>
            Lütfen farklı bir tarih aralığı seçin veya kampanyanın kurulu olduğundan ve analitik ayarlarının açık olduğundan emin olun.
          </p>
        </div>
      );
    }

    const metrics = this.calculateMetrics(data);
    const previousMetrics = this.calculateMetrics(this.state.previousData);

    const calculateChange = (current, previous) => {
      if (!previous) return null;
      const difference = current - previous;
      const percentage = (difference / previous) * 100;
      return percentage.toFixed(2);
    };

    const renderChange = (current, previous, showLabel = true) => {
      if (previous === 0) return null;
      if (!previousStartDate || !previousEndDate) return null;

      const change = calculateChange(current, previous);
      const isPositive = change > 0;
      const color = isPositive ? "green" : "red";
      const icon = isPositive ? "arrow up" : "arrow down";

      const formattedStart = moment(previousStartDate).format("D MMM");
      const formattedEnd = moment(previousEndDate).format("D MMM");

      return (
        <div style={{ marginTop: "5px", fontSize: "12px", color }}>
          <span style={{ fontWeight: "bold" }}>
            <Icon name={icon} />
            {Math.abs(change)}%
          </span>
          {showLabel && (
            <div
              style={{ fontSize: "11px", color: "#7f8c8d", marginTop: "3px" }}
            >
              {formattedStart} - {formattedEnd}
            </div>
          )}
          <div
            style={{ fontSize: "11px", color: "#7f8c8d", fontWeight: "bold" }}
          >
            {previous.toLocaleString()}
          </div>
        </div>
      );
    };
    const funnelChartData = this.getFunnelChartData();
    const pieChartData = this.getPieChartData();
    const referrerData = this.calculateReferrerData(data);
    const previousReferrerData = this.calculateReferrerData(
      this.state.previousData
    );

    return (
      <div
        style={{
          padding: "20px",
          backgroundColor: "#f8f9fa",
          minHeight: "100vh",
        }}
      >
        <Grid stackable style={{ marginBottom: "10px" }}>
          <Grid.Row columns={giveChanceOrderAnalytic ? 6 : 5}>
            <Grid.Column>
              <Card fluid>
                <Card.Content textAlign="center" style={{ padding: "25px" }}>
                  <Statistic>
                    <Statistic.Value style={{ color: "#2c3e50" }}>
                      {metrics.totalVisit.toLocaleString()}
                    </Statistic.Value>
                    <Statistic.Label
                      style={{ fontSize: "14px", fontWeight: "bold" }}
                    >
                      {t("TotalVisit")}
                    </Statistic.Label>
                  </Statistic>
                    <div
                      style={{
                        marginTop: "8px",
                        fontSize: "13px",
                        color: "#7f8c8d",
                      }}
                    >
                      {t("TotalVisitRate")}
                    </div>
                    {renderChange(metrics.totalVisit, previousMetrics.totalVisit)}
                  </Card.Content>
              </Card>
            </Grid.Column>

            <Grid.Column>
              <Card fluid>
                <Card.Content textAlign="center" style={{ padding: "25px" }}>
                  <Statistic>
                    <Statistic.Value style={{ color: "#2185d0" }}>
                      {metrics.capture.toLocaleString()}
                    </Statistic.Value>
                    <Statistic.Label
                      style={{ fontSize: "14px", fontWeight: "bold" }}
                    >
                      {t("CaptureText")}
                    </Statistic.Label>
                  </Statistic>
                  <div
                    style={{
                      marginTop: "8px",
                      fontSize: "13px",
                      color: "#7f8c8d",
                    }}
                  >
                    %{metrics.captureRate} {t("CaptureRate")}
                  </div>
                  {renderChange(metrics.capture, previousMetrics.capture)}
                </Card.Content>
              </Card>
            </Grid.Column>

            <Grid.Column>
              <Card fluid>
                <Card.Content textAlign="center" style={{ padding: "25px" }}>
                  <Statistic>
                    <Statistic.Value style={{ color: "#21ba45" }}>
                      {metrics.pageReturn.toLocaleString()}
                    </Statistic.Value>
                    <Statistic.Label
                      style={{ fontSize: "14px", fontWeight: "bold" }}
                    >
                      {t("CategoryReturnText")}
                    </Statistic.Label>
                  </Statistic>
                  <div
                    style={{
                      marginTop: "8px",
                      fontSize: "13px",
                      color: "#7f8c8d",
                    }}
                  >
                    %{metrics.returnRate} {t("CategoryReturnRate")}
                  </div>
                  {renderChange(metrics.pageReturn, previousMetrics.pageReturn)}
                </Card.Content>
              </Card>
            </Grid.Column>

            <Grid.Column>
              <Card fluid>
                <Card.Content textAlign="center" style={{ padding: "25px" }}>
                  <Statistic>
                    <Statistic.Value style={{ color: "#f2711c" }}>
                      {metrics.productReturn.toLocaleString()}
                    </Statistic.Value>
                    <Statistic.Label
                      style={{ fontSize: "14px", fontWeight: "bold" }}
                    >
                      {t("ProductReturnText")}
                    </Statistic.Label>
                  </Statistic>
                  <div
                    style={{
                      marginTop: "8px",
                      fontSize: "13px",
                      color: "#7f8c8d",
                    }}
                  >
                    %{metrics.productRate} {t("ProductReturnRate")}
                  </div>
                  {renderChange(
                    metrics.productReturn,
                    previousMetrics.productReturn
                  )}
                </Card.Content>
              </Card>
            </Grid.Column>

            <Grid.Column>
              <Card fluid>
                <Card.Content textAlign="center" style={{ padding: "25px" }}>
                  <Statistic>
                    <Statistic.Value style={{ color: "#9b59b6" }}>
                      {metrics.addToCart.toLocaleString()}
                    </Statistic.Value>
                    <Statistic.Label
                      style={{ fontSize: "14px", fontWeight: "bold" }}
                    >
                      {t("AddToCartText")}
                    </Statistic.Label>
                  </Statistic>
                  <div
                    style={{
                      marginTop: "8px",
                      fontSize: "13px",
                      color: "#7f8c8d",
                    }}
                  >
                    %{metrics.cartRate} {t("AddToCartRate")}
                  </div>
                  {renderChange(metrics.addToCart, previousMetrics.addToCart)}
                </Card.Content>
              </Card>
            </Grid.Column>

            {giveChanceOrderAnalytic && (
              <Grid.Column>
                <Card fluid>
                  <Card.Content textAlign="center" style={{ padding: "25px" }}>
                    <Statistic>
                      <Statistic.Value style={{ color: "#16a085" }}>
                        {metrics.purchase.toLocaleString()}
                      </Statistic.Value>
                      <Statistic.Label
                        style={{ fontSize: "14px", fontWeight: "bold" }}
                      >
                        {t("PurchaseText")}
                      </Statistic.Label>
                    </Statistic>
                    <div
                      style={{
                        marginTop: "8px",
                        fontSize: "13px",
                        color: "#7f8c8d",
                      }}
                    >
                      %{metrics.purchaseRate} {t("PurchaseRate")}
                    </div>
                    {renderChange(metrics.purchase, previousMetrics.purchase)}
                  </Card.Content>
                </Card>
              </Grid.Column>
            )}
          </Grid.Row>
        </Grid>

        <Grid stackable>
          <Grid.Row>
            <Grid.Column width={10}>
              <Segment style={{ padding: "20px" }}>
                <Header
                  as="h3"
                  style={{ marginBottom: "20px", color: "#2c3e50" }}
                >
                  <Icon name="chart bar" />
                  {t("PerformanceSummary")}
                </Header>
                <div style={{ height: "300px" }}>
                  <Bar data={funnelChartData} options={barOptions} />
                </div>
              </Segment>
            </Grid.Column>

            <Grid.Column width={6}>
              <Segment style={{ padding: "20px" }}>
                <Header
                  as="h3"
                  style={{ marginBottom: "20px", color: "#2c3e50" }}
                >
                  <Icon name="chart pie" />
                  {t("VisitDistribution")}
                </Header>
                <div style={{ height: "300px" }}>
                  <Doughnut data={pieChartData} options={doughnutOptions} />
                </div>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid stackable>
          <Grid.Row>
            <Grid.Column width={16}>
              <Segment style={{ padding: "20px" }}>
                <Header
                  as="h3"
                  style={{ marginBottom: "20px", color: "#2c3e50" }}
                >
                  <Icon name="globe" />
                  {t("PlatformBasedPerformanceAnalysis")}
                </Header>

                <Grid stackable style={{ marginBottom: "20px" }}>
                  <Grid.Row
                    columns={referrerData.length > 0 ? referrerData.length : 1}
                  >
                    {referrerData.map((item, index) => {
                      let iconName = "world";
                      let iconColor = "#34495e";

                      if (item.referrer === "Google") {
                        iconName = "google";
                        iconColor = "#4285f4";
                      } else if (item.referrer === "Facebook") {
                        iconName = "facebook";
                        iconColor = "#1877f2";
                      } else if (item.referrer === "Instagram") {
                        iconName = "instagram";
                        iconColor = "#e4405f";
                      } else if (item.referrer === "Other") {
                        iconName = "world";
                        iconColor = "#95a5a6";
                      }

                      const previousItem = previousReferrerData.find(
                        (p) => p.referrer === item.referrer
                      );
                      
                      const formattedStart = previousStartDate ? moment(previousStartDate).format("D MMM") : "";
                      const formattedEnd = previousEndDate ? moment(previousEndDate).format("D MMM") : "";

                      return (
                        <Grid.Column key={index}>
                          <Card fluid>
                            <Card.Content
                              textAlign="center"
                              style={{ padding: "25px" }}
                            >
                              <div style={{ marginBottom: "15px" }}>
                                <Icon
                                  name={iconName}
                                  size="big"
                                  style={{ color: iconColor }}
                                />
                              </div>
                              <Header
                                as="h4"
                                style={{
                                  color: "#2c3e50",
                                  marginBottom: "15px",
                                }}
                              >
                                {item.referrer}
                              </Header>
                              
                              {/* Current Values Section */}
                              <Statistic size="small">
                                <Statistic.Value
                                  style={{
                                    color: "#2c3e50",
                                    fontSize: "1.5em",
                                  }}
                                >
                                  {item.campaignShown.toLocaleString()}
                                </Statistic.Value>
                                <Statistic.Label
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {t("TotalVisit")}
                                </Statistic.Label>
                              </Statistic>

                              <div style={{ marginTop: "15px", fontSize: "12px" }}>
                                <div style={{ marginBottom: "8px" }}>
                                  <strong style={{ color: "#2185d0" }}>
                                    {item.tagClick.toLocaleString()}
                                  </strong>{" "}
                                  {t("CaptureText")}
                                </div>
                                <div>
                                  <span
                                    style={{
                                      color:
                                        parseFloat(item.captureRate) > 50
                                          ? "#27ae60"
                                          : "#e74c3c",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    %{item.captureRate}
                                  </span>{" "}
                                  {t("CaptureRate")}
                                </div>
                              </div>

                              {/* Divider */}
                              <div
                                style={{
                                  marginTop: "15px",
                                  marginBottom: "10px",
                                  borderTop: "1px solid #eee",
                                }}
                              />

                              {/* Previous Values / Comparison Section */}
                              {previousItem && (
                                <div style={{ fontSize: "12px", color: "#7f8c8d" }}>
                                  <div style={{ marginBottom: "10px", fontSize: "11px", color: "#95a5a6" }}>
                                     {formattedStart} - {formattedEnd}
                                  </div>
                                  
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                                      <span>{t("TotalVisit")}</span>
                                      {renderChange(
                                        item.campaignShown,
                                        previousItem.campaignShown,
                                        false
                                      )}
                                  </div>

                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                                      <span>{t("CaptureText")}</span>
                                      {renderChange(
                                        item.tagClick,
                                        previousItem.tagClick,
                                        false
                                      )}
                                  </div>

                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                      <span>{t("CaptureRate")}</span>
                                      {renderChange(
                                        parseFloat(item.captureRate),
                                        parseFloat(previousItem.captureRate),
                                        false
                                      )}
                                  </div>
                                </div>
                              )}
                            </Card.Content>
                          </Card>
                        </Grid.Column>
                      );
                    })}
                  </Grid.Row>
                </Grid>

                <Header
                  as="h4"
                  style={{ color: "#34495e", marginBottom: "15px" }}
                >
                  <Icon name="table" />
                  {t("DetailedPlatformStatistics")}
                </Header>
                <Table celled striped>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>{t("Platform")}</Table.HeaderCell>
                      <Table.HeaderCell textAlign="right">
                        {t("TotalVisit")}
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign="right">
                        {t("CaptureText")}
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign="right">
                        {t("CaptureRate")}
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign="right">
                        {t("CategoryReturnText")}
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign="right">
                        {t("CategoryReturnRate")}
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign="right">
                        {t("ProductReturnText")}
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign="right">
                        {t("ProductReturnRate")}
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign="right">
                        {t("AddToCartText")}
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign="right">
                        {t("AddToCartRate")}
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {referrerData.map((item, index) => {
                      const previousItem = previousReferrerData.find(
                        (p) => p.referrer === item.referrer
                      );
                      return (
                        <Table.Row key={index}>
                          <Table.Cell>
                            <strong style={{ textTransform: "capitalize" }}>
                              {item.referrer}
                            </strong>
                          </Table.Cell>
                          <Table.Cell textAlign="right">
                            {item.campaignShown.toLocaleString()}
                            {renderChange(
                              item.campaignShown,
                              previousItem ? previousItem.campaignShown : 0
                            )}
                          </Table.Cell>
                          <Table.Cell textAlign="right">
                            {item.tagClick.toLocaleString()}
                            {renderChange(
                              item.tagClick,
                              previousItem ? previousItem.tagClick : 0
                            )}
                          </Table.Cell>
                          <Table.Cell textAlign="right">
                            <span
                              style={{
                                color:
                                  parseFloat(item.captureRate) > 50
                                    ? "#27ae60"
                                    : "#e74c3c",
                              }}
                            >
                              %{item.captureRate}
                            </span>
                            {renderChange(
                              parseFloat(item.captureRate),
                              previousItem
                                ? parseFloat(previousItem.captureRate)
                                : 0
                            )}
                          </Table.Cell>
                          <Table.Cell textAlign="right">
                            {item.tagReturn.toLocaleString()}
                            {renderChange(
                              item.tagReturn,
                              previousItem ? previousItem.tagReturn : 0
                            )}
                          </Table.Cell>
                          <Table.Cell textAlign="right">
                            <span
                              style={{
                                color:
                                  parseFloat(item.returnRate) > 30
                                    ? "#27ae60"
                                    : "#e74c3c",
                              }}
                            >
                              %{item.returnRate}
                            </span>
                            {renderChange(
                              parseFloat(item.returnRate),
                              previousItem
                                ? parseFloat(previousItem.returnRate)
                                : 0
                            )}
                          </Table.Cell>
                          <Table.Cell textAlign="right">
                            {item.tagProductClick.toLocaleString()}
                            {renderChange(
                              item.tagProductClick,
                              previousItem ? previousItem.tagProductClick : 0
                            )}
                          </Table.Cell>
                          <Table.Cell textAlign="right">
                            <span
                              style={{
                                color:
                                  parseFloat(item.productRate) > 20
                                    ? "#27ae60"
                                    : "#e74c3c",
                              }}
                            >
                              %{item.productRate}
                            </span>
                            {renderChange(
                              parseFloat(item.productRate),
                              previousItem
                                ? parseFloat(previousItem.productRate)
                                : 0
                            )}
                          </Table.Cell>
                          <Table.Cell textAlign="right">
                            {item.tagProductAddedToBasket.toLocaleString()}
                            {renderChange(
                              item.tagProductAddedToBasket,
                              previousItem
                                ? previousItem.tagProductAddedToBasket
                                : 0
                            )}
                          </Table.Cell>
                          <Table.Cell textAlign="right">
                            <span
                              style={{
                                color:
                                  parseFloat(item.cartRate) > 10
                                    ? "#27ae60"
                                    : "#e74c3c",
                              }}
                            >
                              %{item.cartRate}
                            </span>
                            {renderChange(
                              parseFloat(item.cartRate),
                              previousItem
                                ? parseFloat(previousItem.cartRate)
                                : 0
                            )}
                          </Table.Cell>
                        </Table.Row>
                      );
                    })}
                  </Table.Body>
                </Table>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        {giveChanceOrderAnalytic && (
          <Grid stackable>
            <Grid.Row>
              <Grid.Column width={16}>
                <Segment style={{ padding: "20px" }}>
                  <Header
                    as="h3"
                    style={{ marginBottom: "20px", color: "#2c3e50" }}
                  >
                    <Icon name="shopping bag" />
                    {t("OrderNumbersTitle")}
                  </Header>
                  {orderData && orderData.length > 0 ? (
                    <Table celled striped>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell>{t("OrderNumber")}</Table.HeaderCell>
                          <Table.HeaderCell textAlign="right">
                            {t("OrderCount")}
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {orderData.map((item, index) => (
                          <Table.Row key={index}>
                            <Table.Cell>
                              <strong>{item.select3 || "-"}</strong>
                            </Table.Cell>
                            <Table.Cell textAlign="right">
                              {parseInt(item.total_count || 0).toLocaleString()}
                            </Table.Cell>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>
                  ) : (
                    <p style={{ color: "#7f8c8d", textAlign: "center" }}>
                      {t("NoDataAvailable")}
                    </p>
                  )}
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )}

        <Grid stackable>
          <Grid.Row>
            <Grid.Column width={16}>
              <Segment style={{ padding: "20px", backgroundColor: "#f9fafb" }}>
                <Header
                  as="h3"
                  style={{
                    marginBottom: "20px",
                    color: "#2c3e50",
                  }}
                >
                  <Icon name="info circle" />
                  {t("MetricDefinitions")}
                </Header>
                <Grid stackable columns={giveChanceOrderAnalytic ? 6 : 5}>
                  <Grid.Column>
                    <Card fluid>
                      <Card.Content style={{ padding: "20px" }}>
                        <Header
                          as="h4"
                          style={{ color: "#2c3e50", marginBottom: "12px" }}
                        >
                          <Icon name="users" style={{ color: "#2c3e50" }} />
                          {t("TotalVisit")}
                        </Header>
                        <p
                          style={{
                            color: "#7f8c8d",
                            fontSize: "13px",
                            lineHeight: "1.6",
                          }}
                        >
                          {t("TotalVisitDefinition")}
                        </p>
                      </Card.Content>
                    </Card>
                  </Grid.Column>

                  <Grid.Column>
                    <Card fluid>
                      <Card.Content style={{ padding: "20px" }}>
                        <Header
                          as="h4"
                          style={{ color: "#2185d0", marginBottom: "12px" }}
                        >
                          <Icon
                            name="hand point up"
                            style={{ color: "#2185d0" }}
                          />
                          {t("CaptureText")}
                        </Header>
                        <p
                          style={{
                            color: "#7f8c8d",
                            fontSize: "13px",
                            lineHeight: "1.6",
                          }}
                        >
                          {t("CaptureDefinition")}
                        </p>
                      </Card.Content>
                    </Card>
                  </Grid.Column>

                  <Grid.Column>
                    <Card fluid>
                      <Card.Content style={{ padding: "20px" }}>
                        <Header
                          as="h4"
                          style={{ color: "#21ba45", marginBottom: "12px" }}
                        >
                          <Icon name="reply" style={{ color: "#21ba45" }} />
                          {t("CategoryReturnText")}
                        </Header>
                        <p
                          style={{
                            color: "#7f8c8d",
                            fontSize: "13px",
                            lineHeight: "1.6",
                          }}
                        >
                          {t("CategoryReturnDefinition")}
                        </p>
                      </Card.Content>
                    </Card>
                  </Grid.Column>

                  <Grid.Column>
                    <Card fluid>
                      <Card.Content style={{ padding: "20px" }}>
                        <Header
                          as="h4"
                          style={{ color: "#f2711c", marginBottom: "12px" }}
                        >
                          <Icon
                            name="external alternate"
                            style={{ color: "#f2711c" }}
                          />
                          {t("ProductReturnText")}
                        </Header>
                        <p
                          style={{
                            color: "#7f8c8d",
                            fontSize: "13px",
                            lineHeight: "1.6",
                          }}
                        >
                          {t("ProductReturnDefinition")}
                        </p>
                      </Card.Content>
                    </Card>
                  </Grid.Column>

                  <Grid.Column>
                    <Card fluid>
                      <Card.Content style={{ padding: "20px" }}>
                        <Header
                          as="h4"
                          style={{ color: "#9b59b6", marginBottom: "12px" }}
                        >
                          <Icon
                            name="shopping cart"
                            style={{ color: "#9b59b6" }}
                          />
                          {t("AddToCartText")}
                        </Header>
                        <p
                          style={{
                            color: "#7f8c8d",
                            fontSize: "13px",
                            lineHeight: "1.6",
                          }}
                        >
                          {t("AddToCartDefinition")}
                        </p>
                      </Card.Content>
                    </Card>
                  </Grid.Column>

                  {giveChanceOrderAnalytic && (
                    <Grid.Column>
                      <Card fluid>
                        <Card.Content style={{ padding: "20px" }}>
                          <Header
                            as="h4"
                            style={{ color: "#16a085", marginBottom: "12px" }}
                          >
                            <Icon
                              name="shopping bag"
                              style={{ color: "#16a085" }}
                            />
                            {t("PurchaseText")}
                          </Header>
                          <p
                            style={{
                              color: "#7f8c8d",
                              fontSize: "13px",
                              lineHeight: "1.6",
                            }}
                          >
                            {t("PurchaseDefinition")}
                          </p>
                        </Card.Content>
                      </Card>
                    </Grid.Column>
                  )}
                </Grid>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default connect((state) => ({
  user: state.access.user.loggedUserObj,
  product: state.product.personalize,
  giveChanceOrderAnalytic:
    state.product.personalize &&
    state.product.personalize.settings &&
    state.product.personalize.settings.giveChanceOrderAnalytic,
}))(withTranslation()(BirSansVerAnalytic));
